import { useEffect, useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://api.binko.me';

export default function VenueAuthGuard({ children }) {
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('binko_venue_token');
    if (!token) {
      window.location.href = '/venue/login';
      return;
    }
    fetch(`${API}/api/venue/me`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (res.status === 401 || res.status === 403) {
          localStorage.removeItem('binko_venue_token');
          localStorage.removeItem('binko_venue_name');
          window.location.href = '/venue/login';
        } else {
          setVerified(true);
        }
      })
      .catch(() => {
        // Network error — fail closed. A dropped packet must not bypass auth.
        window.location.href = '/venue/login';
      });
  }, []);

  if (!verified) return null;
  return children;
}
